interface Props {
  onClose: () => void;
  onRequestSupport: () => void;
}

const services = [
  "Hospitals, clinics and other health facilities work permits/license",
  "Human medicines retailers license acquisition",
  "Human medicines wholesaler license acquisition",
  "Human medical devices supplier license acquisition",
  "Medicines registration",
  "Medical devices registration",
  "Medical products & devices importation license acquisition",
  "Medical products & devices exportation license acquisition",
];

export default function HealthServicesModal({ onClose, onRequestSupport }: Props) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/40"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div
        className="bg-white rounded-2xl w-full max-w-lg shadow-xl relative flex flex-col max-h-[90vh]"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close button */}
        <button
          type="button"
          onClick={onClose}
          className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 text-gray-500 hover:text-gray-700 transition-colors cursor-pointer z-10"
          aria-label="Close"
        >
          <i className="ri-close-line text-base" />
        </button>

        {/* Header */}
        <div className="flex items-center gap-4 px-7 pt-7 pb-5 shrink-0">
          <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-[#E6FAFA] shrink-0">
            <i className="ri-heart-pulse-line text-xl text-[#00C2C2]" />
          </div>
          <h3 className="text-[#0A1628] font-bold text-xl">Health Services</h3>
        </div>

        {/* Divider */}
        <div className="h-px bg-gray-100 mx-7 shrink-0" />

        {/* Services list */}
        <div className="overflow-y-auto flex-1 px-7 py-5">
          <ul className="space-y-3">
            {services.map((service) => (
              <li key={service} className="flex items-start gap-3">
                <span className="w-2 h-2 rounded-full bg-[#00C2C2] mt-1.5 shrink-0" />
                <span className="text-gray-700 text-sm leading-relaxed">{service}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* Footer */}
        <div className="px-7 pb-7 pt-4 shrink-0">
          <button
            type="button"
            onClick={onRequestSupport}
            className="w-full py-4 rounded-xl bg-[#0A1628] text-white font-semibold text-sm hover:bg-[#0A1628]/90 transition-colors cursor-pointer whitespace-nowrap"
          >
            Request Support
          </button>
        </div>
      </div>
    </div>
  );
}